import React from "react";
import { Button, Modal } from "react-bootstrap";

export const ReceiptGenerationResultModal = ({
  show,
  status,
  onHide,
  onDownloadReceipt,
  selectedPaymentSearch,
}) => {
  const isSuccess = status === "success";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
        <Modal.Title>
          {isSuccess ? "✅ " : "❌ "}
          {isSuccess
            ? "E-Receipt Generated Successfully!"
            : "E-Receipt Generation Failed"}
        </Modal.Title>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isSuccess ? (
          <>
            <p>
              The E-Receipt has been successfully generated and delivered to the
              customer via the following channels:
            </p>
            <ul>
              <li>
                <strong>Email:</strong> {selectedPaymentSearch?.customerEmail}
              </li>
              <li>
                <strong>SMS:</strong>{" "}
                {selectedPaymentSearch?.customerMobileNumber}
              </li>
            </ul>
            <p>
              Customer:{" "}
              <strong>
                {selectedPaymentSearch?.customerFirstName}{" "}
                {selectedPaymentSearch?.customerLastName}
              </strong>
            </p>
            <p className="mb-0">
              Please download the E-Receipt on behalf of the customer by
              clicking the button below.
            </p>
          </>
        ) : (
          <>
            <p>
              We encountered an error while generating the E-Receipt for the
              following customer:
            </p>
            <p>
              <strong>
                {selectedPaymentSearch?.customerFirstName}{" "}
                {selectedPaymentSearch?.customerLastName}
              </strong>
            </p>
            <p className="mb-0 text-danger">
              Please try again later or contact support if the issue persists.
            </p>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        {isSuccess ? (
          <Button variant="primary" onClick={onDownloadReceipt}>
            Download E-Receipt
          </Button>
        ) : (
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
